import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { environment } from '@env/environment';
import { IBankRequest } from '../../new-bank-request/bank-request.interface';

/**
 * new bank request service
 */
@Injectable({
    providedIn: 'root'
})
export class NewBankRequestService {

    constructor(private http: HttpClient) {}

    create(data): Observable<any> {
        return this.http.post(environment.API_URL + '/new-bank-request', data)
            .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
    }

    list(): Observable<IBankRequest[]> {
        return this.http.get<IBankRequest[]>(environment.API_URL + '/new-bank-request')
            .pipe(catchError((error: HttpErrorResponse) => throwError(error)));
    }
}
